"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.QuickAccess = exports.Item = exports.Icon = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _utils = require("../../utils");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var QuickAccess = exports.QuickAccess = _styledComponents["default"].div.withConfig({
  displayName: "QuickAccessstyle__QuickAccess",
  componentId: "sc-1iap7xz-0"
})(function (_ref) {
  var spacing = _ref.theme.spacing;
  return {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
    height: spacing.inline['7xl'],
    overflow: 'hidden'
  };
});
var Item = exports.Item = _styledComponents["default"].a.withConfig({
  displayName: "QuickAccessstyle__Item",
  componentId: "sc-1iap7xz-1"
})(function (_ref2) {
  var theme = _ref2.theme;
  return _objectSpread(_objectSpread({
    flex: '1 0',
    minWidth: '112px',
    boxSizing: 'border-box',
    transition: '0.1s',
    background: 'transparent',
    border: 'none',
    borderLeft: "1px solid ".concat(theme.color.line.medium),
    display: 'inline-block',
    textAlign: 'center',
    padding: theme.spacing.inline['6xs'],
    cursor: 'pointer',
    outline: 'none',
    textDecoration: 'none',
    color: theme.color.brandPrimary.light,
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'nowrap'
  }, (0, _utils.getTextStyle)({
    theme: theme,
    variant: 'caption-02',
    margin: false
  })), {}, {
    ':first-child': {
      borderLeft: 'none'
    },
    ':hover': {
      color: theme.color.brandPrimary.medium
    }
  });
});
var Icon = exports.Icon = _styledComponents["default"].svg.withConfig({
  displayName: "QuickAccessstyle__Icon",
  componentId: "sc-1iap7xz-2"
})(function (_ref3) {
  var _ref3$theme = _ref3.theme,
    color = _ref3$theme.color,
    spacing = _ref3$theme.spacing;
  return {
    display: 'block',
    width: spacing.inline.xs,
    height: spacing.inline.xs,
    margin: '0 auto 8px',
    fill: color.brandSecondary.dark
  };
});